import React from "react";
import PropTypes from "prop-types";
import { getPropsFromData, InputField } from "../../FormField";

const DependentRecord = ({ fieldNamePrefix, relationship, data }) => {
  return (
    <tr>
      <td>{relationship}</td>
      <td>
        <InputField {...getPropsFromData(data, `${fieldNamePrefix}Name`)} />
      </td>
      <td>
        <InputField {...getPropsFromData(data, `${fieldNamePrefix}Identification`)} />
      </td>
      <td>
        <InputField {...getPropsFromData(data, `${fieldNamePrefix}Gender`)} />
      </td>
      <td>
        <InputField {...getPropsFromData(data, `${fieldNamePrefix}BirthDateDay`)} />
      </td>
      <td>
        <InputField {...getPropsFromData(data, `${fieldNamePrefix}BirthDateMonth`)} />
      </td>
      <td>
        <InputField {...getPropsFromData(data, `${fieldNamePrefix}BirthDateYear`)} />
      </td>
      <td>
        <InputField style={{ width: 50 }} {...getPropsFromData(data, `${fieldNamePrefix}Height`)} />
      </td>
      <td>
        <InputField style={{ width: 50 }} {...getPropsFromData(data, `${fieldNamePrefix}Weight`)} />
      </td>
    </tr>
  );
};

DependentRecord.propTypes = {
  fieldNamePrefix: PropTypes.string.isRequired,
  relationship: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  data: PropTypes.object,
};

export default DependentRecord;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/RHI/RHIHD201907/DependentRecord.jsx